import { useEffect } from "react";
import { motion, useMotionValue, useSpring } from "framer-motion";

// Soft blue ambient glow that subtly follows the cursor across the page.
export default function MouseGlow() {
  const x = useMotionValue(-400);
  const y = useMotionValue(-400);
  const sx = useSpring(x, { stiffness: 45, damping: 22, mass: 0.6 });
  const sy = useSpring(y, { stiffness: 45, damping: 22, mass: 0.6 });

  useEffect(() => {
    const move = (e) => { x.set(e.clientX); y.set(e.clientY); };
    window.addEventListener("mousemove", move, { passive: true });
    return () => window.removeEventListener("mousemove", move);
  }, [x, y]);

  return (
    <motion.div
      aria-hidden
      className="pointer-events-none fixed z-0 hidden md:block"
      style={{
        left: sx, top: sy, x: "-50%", y: "-50%",
        width: 520, height: 520, borderRadius: "9999px",
        background: "radial-gradient(circle, rgba(77,166,255,0.10) 0%, rgba(77,166,255,0.04) 35%, transparent 70%)",
        filter: "blur(40px)",
      }}
    />
  );
}
